/**
 * 浏览器判断
 * @author lianghua.fu
 * @date 2017-10-23 16:31:23
 */

import { log } from './debug';

type OsType = {
  android?: boolean;
  ipad?: boolean;
  ipod?: boolean;
  iphone?: boolean;
  ios?: boolean;
  wechat?: boolean;
  mac?: boolean;
  wechatDevTools?: boolean;
  meme?: boolean;
  memeNative?: boolean;
  // 么么直播客户端 qt 内嵌
  memeClient?: boolean;
  laihouNative?: boolean;
  huawei?: boolean;
  qq?: boolean;
  wechatVersion?: string;
  iPhoneX?: boolean;
  iPhoneXS?: boolean;
  iPhoneXSMax?: boolean;
  iPhoneXR?: boolean;
};

const os: OsType = {};

function detect(ua, platform) {
  os.android = !!ua.match(/(Android);?[\s/]+([\d.]+)?/i);
  os.ipad = !!ua.match(/(iPad).*OS\s([\d_]+)/i);
  os.ipod = !!ua.match(/(iPod)(.*OS\s([\d_]+))?/i);
  os.iphone = !os.ipad && !!ua.match(/(iPhone\sOS)\s([\d_]+)/i);
  os.ios = os.ipad || os.ipod || os.iphone;
  os.mac = !!ua.match(/macintosh|mac os x/i);
  os.wechat = !!ua.match(/MicroMessenger/i);
  os.wechatDevTools = !!ua.match(/wechatdevtools/i);
  os.meme = !!ua.match(/MeMeBrowser/i);
  os.memeNative = !!ua.match(/MeMeBrowserNative/i);
  os.laihouNative = !!ua.match(/LaiHouBrowserNative/i);
  os.huawei = !!ua.match(/HUAWEI/i);
  os.qq = !!ua.match(/QQ/i);
  const wechatVersion =
    ua.match(/micromessenger\/(\d+\.\d+\.\d+)/) ||
    ua.match(/micromessenger\/(\d+\.\d+)/);
  os.wechatVersion = wechatVersion ? wechatVersion[1] : '';

  // "Mozilla/5.0 (Windows NT 6.2; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) QtWebEngine/5.15.2 Chrome/83.0.4103.122 Safari/537.36"
  os.memeClient =
    !!ua.match(/Electron/i) &&
    (!!ua.match(/meme-live-client/i) || !!ua.match(/www.2339.com-v2/i));

  // iPhone X、iPhone XS
  // eslint-disable-next-line no-multi-assign
  os.iPhoneX = os.iPhoneXS =
    /iphone/gi.test(window.navigator.userAgent) &&
    !!window.devicePixelRatio &&
    window.devicePixelRatio === 3 &&
    window.screen.width === 375 &&
    window.screen.height === 812;
  // iPhone XS Max
  os.iPhoneXSMax =
    /iphone/gi.test(window.navigator.userAgent) &&
    !!window.devicePixelRatio &&
    window.devicePixelRatio === 3 &&
    window.screen.width === 414 &&
    window.screen.height === 896;
  // iPhone XR
  os.iPhoneXR =
    /iphone/gi.test(window.navigator.userAgent) &&
    !!window.devicePixelRatio &&
    window.devicePixelRatio === 2 &&
    window.screen.width === 414 &&
    window.screen.height === 896;
}

if (typeof navigator !== 'undefined') {
  detect(navigator.userAgent.toLowerCase(), navigator.platform);

  log('os', os);
  window._browser = os;
}
export default os;
